import { render, staticRenderFns } from "./DeliveryStepDeliverOrder.vue?vue&type=template&id=1570f80b&"
import script from "./DeliveryStepDeliverOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepDeliverOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStepDeliverOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports